// Shared lemma-prefix logic for highlighting target words in chapter
// passages. The naive regex `\b{lemma}\w*\b` misses common English
// inflections that mutate the lemma's tail — e.g. "make" → "making"
// (silent 'e' drops), "petrify" → "petrified" (y → ied), "reminisce" →
// "reminiscing", "hurtle" → "hurtling". Stripping the trailing 'y' or
// silent 'e' gives an invariant root the regex can anchor on.

export function lemmaPrefix(lemma) {
  if (!lemma) return lemma;
  if (/y$/i.test(lemma)) return lemma.slice(0, -1);
  if (/e$/i.test(lemma)) return lemma.slice(0, -1);
  return lemma;
}

function escapeRegex(s) {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

// Returns a case-insensitive regex that matches the lemma plus any
// inflection-suffix the prefix admits. Uses a word-boundary anchor at
// both ends so we don't overmatch into longer unrelated words.
export function lemmaSurfaceRegex(lemma, flags = 'i') {
  const prefix = lemmaPrefix(lemma);
  return new RegExp(`\\b${escapeRegex(prefix)}\\w*\\b`, flags);
}
